/**
 * @generated SignedSource<<1f558ec370ee4e3b194d388227409c92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateFeatureFlagCohortInput = {
  name?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createFeatureFlagCohortMutation$variables = {
  input: CreateFeatureFlagCohortInput;
};
export type createFeatureFlagCohortMutation$data = {
  readonly CreateFeatureFlagCohort: {
    readonly missionControlData: {
      readonly id: string;
      readonly featureFlagLists: {
        readonly id: string;
        readonly cohorts: ReadonlyArray<{
          readonly id: string;
          readonly cohortId: number | null;
          readonly name: string | null;
          readonly companyIds: ReadonlyArray<number | null> | null;
        } | null> | null;
        readonly alwaysLastCompanyIds: ReadonlyArray<number | null> | null;
      } | null;
    } | null;
  } | null;
};
export type createFeatureFlagCohortMutation = {
  variables: createFeatureFlagCohortMutation$variables;
  response: createFeatureFlagCohortMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateFeatureFlagCohortPayload",
    "kind": "LinkedField",
    "name": "CreateFeatureFlagCohort",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlDataType",
        "kind": "LinkedField",
        "name": "missionControlData",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlFeatureFlagListsType",
            "kind": "LinkedField",
            "name": "featureFlagLists",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MissionControlFeatureFlagCohortType",
                "kind": "LinkedField",
                "name": "cohorts",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cohortId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyIds",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alwaysLastCompanyIds",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createFeatureFlagCohortMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createFeatureFlagCohortMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e4cec905ba66a41ce0e54f4ffcafda81",
    "id": null,
    "metadata": {},
    "name": "createFeatureFlagCohortMutation",
    "operationKind": "mutation",
    "text": "mutation createFeatureFlagCohortMutation(\n  $input: CreateFeatureFlagCohortInput!\n) {\n  CreateFeatureFlagCohort(input: $input) {\n    missionControlData {\n      id\n      featureFlagLists {\n        id\n        cohorts {\n          id\n          cohortId\n          name\n          companyIds\n        }\n        alwaysLastCompanyIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d25f52fad236625bc71b2f8e5cd55fc";

export default node;
